import { useEffect, useState } from "react";
import { IMAGE_URL } from "../../path";

interface FourImageGalleryProps {
    id: number;
    image_1: string;
    image_2: string;
    image_3: string;
    image_4: string;
}

function Custom4ImageGalleryComponent(props: FourImageGalleryProps) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const imagePath = IMAGE_URL;

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth <= 575;

    return (
        <div
            key={props.id}
            style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: '16px',
                marginBottom: '100px',
                marginLeft: isMobile ? '26px' : 'auto',
                marginRight: isMobile ? '26px' : 'auto',
                justifyContent: isMobile ? 'flex-start' : 'space-between',
                alignItems: 'flex-start',
                width: isMobile ? `calc(100% - 52px)` : '95%', // full width minus 26px margins each side
            }}
        >
            {[props.image_1, props.image_2, props.image_3, props.image_4].map((img, idx) => (
                <div key={idx} style={{ flex: isMobile ? 'unset' : 1 }}>
                    <img
                        src={imagePath + img}
                        alt={img}
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                </div>
            ))}
        </div>
    );
}

export default Custom4ImageGalleryComponent;
